import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import i18n from 'i18next';
import { Popover, Image, Button, GlobalSearch, Helper } from 'Components';
import BureauVeritasLogo from 'assets/bv-logo-sm.svg';
import history from 'src/history';
import './Dash.css';

class Dash extends React.Component {
  constructor(props) {
    super(props);
    i18n.setDefaultNamespace('dash');

    this.state = {
      showPopover: false,
      showSearch: false,
      links: [
        {
          title: 'My Account',
          destination: '/my-account',
          icon: 'person',
        },
        {
          title: 'Email Notifications',
          destination: '/email-notifications',
          icon: 'email',
        },
        ...(this.props.hasLoginAsAdmin ? [{
          title: 'Login as Admin',
          destination: '/admin',
          icon: 'supervised_user_circle',
        }] : []),
        ...(this.props.hasManageAccess ? [{
          title: 'Manage Access',
          destination: '/manage-access/current-users',
          icon: 'lock',
        }] : []),
        {
          title: 'Logout',
          destination: '/login',
          icon: 'input',
        },
      ],
    };

    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.popoverRef = React.createRef();
    this.searchRef = React.createRef();
    this.handleClickOutsidePopover = this.handleClickOutsidePopover.bind(this);
    this.handleClickOutsideSearch = this.handleClickOutsideSearch.bind(this);
    this.handlePopoverClick = this.handlePopoverClick.bind(this);
    this.handleGlobalSearchClose = this.handleGlobalSearchClose.bind(this);
  }

  handleClickOutsidePopover(e) {
    if (this.popoverRef.current) {
      if (this.popoverRef.current.contains(e.target)) {
        e.preventDefault();
        return;
      }
      this.handlePopoverClick();
    }
  }

  handleClickOutsideSearch(e) {
    if (this.searchRef.current) {
      if (this.searchRef.current.contains(e.target)) {
        return;
      }

      // Global Search Exact Match Checkbox
      if (e.target.textContent === 'check') {
        return;
      }

      if (((e.target.childNodes[0] || {}).classList ||
        document.querySelectorAll('.dash')[0].classList).contains('nav__desktop')) {
        return;
      }

      // check to see if an element composing react-datepicker has been clicked
      const classes = e.target.classList;
      for (let i = 0; i !== classes.length; i += 1) {
        if (/react-datepicker/g.test(classes.item(i))) { return; }
      }


      this.handleSearchClick();
    }
  }

  handleMenuItemClick(event, index) {
    event.stopPropagation();
    this.setState({ showPopover: false });
    document.removeEventListener('click', this.handleClickOutsidePopover, false);
    const { destination } = this.state.links[index];

    if (destination === '/login') {
      return this.props.handleLogout();
    }
    return history.push(destination);
  }

  handleSearchClick() {
    if (!this.state.showSearch) {
      document.addEventListener('click', this.handleClickOutsideSearch, false);
    } else {
      document.removeEventListener('click', this.handleClickOutsideSearch, false);
    }
    this.setState(prevState => ({
      showSearch: !prevState.showSearch,
    }));
  }

  handlePopoverClick() {
    if (!this.state.showPopover) {
      document.addEventListener('click', this.handleClickOutsidePopover, false);
    } else {
      document.removeEventListener('click', this.handleClickOutsidePopover, false);
    }
    this.setState(prevState => ({
      showPopover: !prevState.showPopover,
    }));
  }

  handleGlobalSearchClose() {
    document.removeEventListener('click', this.handleClickOutsideSearch, false);
    this.setState({ showSearch: false });
  }

  render() {
    const nodes = window.location.pathname.split('/');
    let loc;
    if (nodes.length > 1) {
      loc = nodes[1].toLowerCase();
    }

    const translatedLinks = this.state.links.map(link => ({
      title: i18n.t(link.title),
      destination: link.destination,
      icon: link.icon,
    }));

    return (
      <Fragment>
        <div className="dash">
          {
            this.props.isNavCollapsed
            ? (
              <div className="bureau-beritas-logo--collapsed">
                <Button onClick={() => history.push('/')}>
                  <Image src={BureauVeritasLogo} alt="Bureau Veritas Logo" />
                </Button>
              </div>
            ) : <div />
          }
          <div>
            <div className="dash__vertical--large" />

            <Helper text={i18n.t('tutorials:dashboardOverview.10')}>
              <Button className="dash__search" onClick={this.handleSearchClick}>
                <div className="dash__link">
                  <b>{i18n.t('common:Search')}</b>
                </div>
                <i className="material-icons">search</i>
              </Button>
            </Helper>

            <div className="dash__vertical--large" />

            <div className="dash__link">
              <Link to="/">{i18n.t('Home')}</Link>
            </div>
            <div className="dash__vertical--small" />

            <Helper text={i18n.t('tutorials:dashboardOverview.12')}>
              <div className="dash__link">
                <Link to="/custom-reports" className={(loc === 'custom-reports') ? 'dash__link--active' : undefined}>{i18n.t('Custom Reports')}</Link>
              </div>
            </Helper>

            <div className="dash__vertical--small" />

            <Helper text={i18n.t('tutorials:dashboardOverview.14')}>
              <div className="dash__link">
                <Link to="/resources" className={(loc === 'resources') ? 'dash__link--active' : undefined}>{i18n.t('Resources')}</Link>
              </div>
            </Helper>
            <div className="dash__vertical--small" />
            <Helper text={i18n.t('tutorials:dashboardOverview.13')}>
              <span className="dash__region">{i18n.t(`common:${this.props.userInfo.Region}`)}</span>
            </Helper>

            <div className="dash__vertical--large" />

            <div className="dash__user">
              <div><span>{i18n.t('Welcome')}</span></div>
              <Button onClick={this.handlePopoverClick} >
                <div className="dash__user__name">
                  <span>{this.props.userInfo.UserName}</span>
                  <i className="material-icons">arrow_drop_down</i>
                </div>
              </Button>
            </div>
          </div>
          {
            this.state.showPopover &&
            <Popover
              domRef={this.popoverRef}
              onClick={this.handleMenuItemClick}
              links={translatedLinks}
            />
          }
        </div>
        <div className="dash__bottom__gradient" />
        {this.props.isLoggedInAsAdmin && <div className="dash__loggedin-as-admin">You are currently logged in as Admin</div>}
        { this.state.showSearch &&
          <GlobalSearch
            deviceIndex={this.props.deviceIndex}
            submissionTypeOptions={this.props.submissionTypeOptions}
            clients={this.props.clients.options}
            domRef={this.searchRef}
            handleClose={this.handleGlobalSearchClose}
            handleClickOutside={this.handleClickOutsideSearch}
            filterFieldValue={this.props.filterFieldValue}
            filterItemValue={this.props.filterItemValue}
            hasAccessToInvoices={this.props.userInfo.HasAccessToInvoices}
            isInternalUser={this.props.userInfo.IsInternalUser}
            clientNumber={this.props.userInfo.ClientNumber}

            hasAccessToAA={this.props.userInfo.LOB !== "F"}
          />
        }
      </Fragment>
    );
  }
}

Dash.propTypes = {
  deviceIndex: PropTypes.number,
  clients: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.shape({
      options: PropTypes.string,
      value: PropTypes.string,
    })),
  }),
  submissionTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    options: PropTypes.string,
    value: PropTypes.number,
  })),
  handleLogout: PropTypes.func,
  isNavCollapsed: PropTypes.bool,
  isLoggedInAsAdmin: PropTypes.bool,
  hasManageAccess: PropTypes.bool,
  userInfo: PropTypes.shape({
    UserName: PropTypes.string,
    UserLanguage: PropTypes.string,
    LOB: PropTypes.string,
    Region: PropTypes.string,
    IsSuperUser: PropTypes.bool,
    IsInternalUser: PropTypes.bool,
    HasAccessToInvoices: PropTypes.bool,
    ClientNumber: PropTypes.string,
  }),
  filterFieldValue: PropTypes.string,
  filterItemValue: PropTypes.string,
  hasLoginAsAdmin: PropTypes.bool,
};

export default Dash;



// WEBPACK FOOTER //
// ./src/containers/Dash/Dash.jsx